import { render, staticRenderFns } from "./EventMain.vue?vue&type=template&id=526eae51&"
import script from "./EventMain.vue?vue&type=script&lang=js&"
export * from "./EventMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports